module.exports = __webpack_public_path__ + "26ea01b49dd6f58b23d18e762b6e6065.svg";